import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { LOneApprovalListComponent } from './l-one-approval/l-one-approval-list/l-one-approval-list.component';
import { SeparationApprovalListComponent } from './separation-approval-list/separation-approval-list.component';
import { SeparationListComponent } from './separation-list/separation-list.component';
import { SeparationWizardComponent } from './separation-wizard/separation-wizard.component';
import { TerminantionEmpAppealComponent } from './terminantion-emp-appeal/terminantion-emp-appeal.component';
import { TerminationListComponent } from './termination-list/termination-list.component';
import { TerminationWizardComponent } from './termination-wizard/termination-wizard.component';

const routes: Routes = [
  {
    path: 'lone-approval',
    component: LOneApprovalListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'lone-approval',
      modules: ['SEPARATION']
    },
  },
  {
    path: 'separation-approval-list',
    component: SeparationApprovalListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'separation-approval-list',
      modules: ['SEPARATION']
    },
  },
  {
    path: 'separation-list',
    component: SeparationListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'separation-list',
      modules: ['SEPARATION']
    },
  },
  {
    path: 'separation-wizard',
    component: SeparationWizardComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'separation-wizard',
      modules: ['SEPARATION']
    },
  },
  {
    path: 'termination-list',
    component: TerminationListComponent,
    canActivate: [ModuleGuard],
    data: {
      title: 'termination-list',
      modules: ['SEPARATION']
    },
  },
  {
    path: 'termination-wizard',
    component: TerminationWizardComponent,
    canActivate:[ModuleGuard],
        data: {
          title: 'termination-wizard',
          modules:['SEPARATION']
        },
  },
  {
    path: 'termination-appeal-list',
    component: SeparationApprovalListComponent,
    canActivate:[ModuleGuard],
        data: {
          title: 'termination-appeal-list',
          modules:['SEPARATION']
        },
  },
  {
    path: 'termination-appeal',
    component: TerminantionEmpAppealComponent,
    canActivate:[ModuleGuard],
        data: {
          title: 'termination-appeal',
          modules:['SEPARATION']
        },
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeparationRoutingModule { }
